/* 🤖 this file was generated by svg-to-ts */
export const mgcIconPencilFilled: {
  name: 'pencil-filled';
  data: string;
} = {
  name: 'pencil-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M17.553 2.318c-.768.141-1.226.406-1.933 1.119l-.439.444L17.65 6.35l2.469 2.469.424-.419c.634-.628.895-1.026 1.056-1.606a3.054 3.054 0 0 0-.385-2.463c-.198-.303-1.249-1.354-1.547-1.547a3.532 3.532 0 0 0-.927-.41c-.249-.069-.937-.102-1.187-.056M9.134 9.93c-3.206 3.209-4.673 4.703-4.731 4.82-.046.093-.329 1.227-.627 2.52-.611 2.643-.615 2.676-.393 3.035.073.118.194.239.312.312.358.221.401.216 2.945-.373 2.585-.598 2.473-.568 2.693-.7.092-.054 2.242-2.175 4.777-4.712l4.61-4.612-2.47-2.47-2.47-2.47z"/></svg>`
};
